// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Menu = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M12.37,17.09A5.09,5.09,0,1,1,17.46,12,5.1,5.1,0,0,1,12.37,17.09Zm0-9.18A4.09,4.09,0,1,0,16.46,12,4.1,4.1,0,0,0,12.37,7.9Z" />
            <Path d="M20.24,32.1a.5.5,0,0,1-.5-.5V23.73A4.75,4.75,0,0,0,15,19H9.75A4.75,4.75,0,0,0,5,23.73V31.6a.5.5,0,1,1-1,0V23.73A5.75,5.75,0,0,1,9.75,18H15a5.75,5.75,0,0,1,5.75,5.75V31.6A.5.5,0,0,1,20.24,32.1Z" />
            <Path d="M35.5,10.75h-14a.5.5,0,0,1,0-1h14a.5.5,0,0,1,0,1Z" />
            <Path d="M35.5,20.25h-11a.5.5,0,0,1,0-1h11a.5.5,0,0,1,0,1Z" />
            <Path d="M35.5,29.75h-8a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" />
        </G>
    );
};

export default Menu;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/menu/index.js